import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2cj1776q: FaireBrandEntity = {
  token: "b_2cj1776q",
  type: "brand",
  name: "Peking Handicraft",
  avatarUrl:
    "https://cdn.faire.com/fastly/aeb2a60665868f8114e52f357c188b0fc7e9e7427b7805b35ac09c60f3c5f7be.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a32e2fc9b9ac9525ebd026e783f42b9561d3795e0a86cf8f87587d8210c69b31.png",
  logoUrl:
    "https://cdn.faire.com/fastly/aeb2a60665868f8114e52f357c188b0fc7e9e7427b7805b35ac09c60f3c5f7be.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a32e2fc9b9ac9525ebd026e783f42b9561d3795e0a86cf8f87587d8210c69b31.png",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 2890,
  isTopShop: true,
  isInsider: true,
  description:
    "Peking Handicraft is a global manufacturer specializing in home textiles, decorative accessories and gift items. Our variety of products consists of renowned designer collections as well as exciting designs from our in-house design studio. Both are trend right and of exceptional quality and value.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:47.595Z",
    importedBy: "entity-db-cli",
  },
};
